export default __webpack_public_path__ + "static/alchemy-17dba7005f995f0ac3325072fc02d203.png";